import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { z } from "zod";
import { Clients } from "@/lib/clients";
import { Tables } from "@/gen/tableNames/tables";
import { useTranslation } from "react-i18next";

const filterC3DedicatedFundsSchema = z.object({
  date_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  date_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  strategy_from_id_equals: z.coerce.number().optional().nullable(),
  strategy_to_id_equals: z.coerce.number().optional().nullable(),
});

export type FilterC3DedicatedFundsSchema = z.infer<
  typeof filterC3DedicatedFundsSchema
>;

export function FilterC3DedicatedFunds() {
  const { t } = useTranslation("tables");
  const fields: Field[] = [
    {
      name: "date",
      type: "dateRange",
      label: t("c3_dedicated_funds.searchbox.date", { defaultValue: "Date" }),
      from: { name: "date_from" },
      to: { name: "date_to" },
      col_span: 2,
    },
    {
      name: "strategy_from_id_equals",
      label: t("c3_dedicated_funds.searchbox.strategy_from_id_equals", { defaultValue: "Strategy from ID" }),
      type: "input",
    },
    {
      name: "strategy_to_id_equals",
      label: t("c3_dedicated_funds.searchbox.strategy_to_id_equals", { defaultValue: "Strategy to ID" }),
      type: "input",
    },
  ];
  return (
    <FilterTable
      schema={filterC3DedicatedFundsSchema}
      client={Clients.C3}
      tableName={Tables.C3_DEDICATED_FUNDS}
      fields={fields}
      columns={2}
    />
  );
}
